import moment from "moment";

export default function adaptRentingApprovalCalculationsPayload({
  privateUsePercentage,
  energeticEfficiency,
  purchasePrice,
  initialAmount,
  rentingQuota,
  rentingCompanyQuota,
  rentingEmployeeQuota,
  date,
  numberOfQuotas,
  whoPaysQuotas,
  whoPaysVat,
}) {
  const getInitialPayment = (type) =>
    whoPaysQuotas === type ? initialAmount * 100 : 0;

  const getRentingQuota = (type, rentingType) =>
    whoPaysQuotas === type ? 0 : rentingType * 100;

  return {
    energyEfficiency: energeticEfficiency / 100,
    vehiclePrice: purchasePrice * 100,
    privateUseRatio: privateUsePercentage / 100,
    numberOfPayments: Number(numberOfQuotas),
    initialPaymentByEmployee:
      whoPaysQuotas === "both"
        ? initialAmount * 100
        : getInitialPayment("employee"),
    initialPaymentByCompany: getInitialPayment("company"),
    rentingCostPerPaymentEmployee:
      whoPaysQuotas === "employee"
        ? rentingQuota * 100
        : getRentingQuota("company", rentingEmployeeQuota),
    rentingCostPerPaymentCompany:
      whoPaysQuotas === "company"
        ? rentingQuota * 100
        : getRentingQuota("employee", rentingCompanyQuota),
    VATSupportedBy: whoPaysVat === "employee" ? "empleado" : "empresa",
    serviceStart: moment(Math.round(date.getTime())).format("YYYY-MM-DD"),
  };
}
